<template>
    <ul ref="chatContainerRef" class="chat-container">
        <li v-for="(chat, index) in listData" :key="index">
            <div class="datetime"
                v-if="index === 0 || (index > 0 && ($moment(chat.created).format('YYMMDD') != $moment(listData[index - 1].created).format('YYMMDD')))">
                <span class="t-helper">
                    {{ $moment(chat.created).format('LL') }}
                </span>
            </div>

            <!-- 이미지 -->
            <div class="chat-body" v-for="(attachment, index2) in chat.attachments" :key="index2" :class="{
                'me': chat.owner,
                'other': !chat.owner,
                'with-avatar': index === 0 && !chat.owner,
                'with-avatar': index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner,
                'first': index > 0 && listData[index - 1].writer.id !== chat.writer.id,
            }">
                <div class="user-name" v-if="!chat.owner">
                    {{ chat.writer.name ? chat.writer.name.last + ' ' + chat.writer.name.first : $t("S10082") }}
                    <ProfileTierName :data="chat.writer" :class="'mgb-8 t-color-white chat-tier-name-background'" />
                </div>

                <div class="picture position-relative" v-if="!chat.owner"
                    :class="{ 'first-avatar': (index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner) }">
                    <img class="avatar" :src="chat.writer.profile || '/home/images/avatar.svg'" alt=""
                        v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)" />
                    <ProfileTier :data="chat.writer"
                        v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)"
                        className="'size-18'" />
                </div>
                <img :src="attachment.resourceUri" alt="" class="attachment">
                <span class="t-helper">
                    {{ $moment(chat.created).format('LT') }}
                    <!-- {{$moment(chat.created).format('LLLL')}} -->
                </span>
            </div>
            <div class="chat-body" :class="{
                'me': chat.owner,
                'other': !chat.owner,
                'with-avatar': index === 0 && !chat.owner,
                'with-avatar': index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner,
                'first': index > 0 && listData[index - 1].writer.id !== chat.writer.id,
            }" v-if="chat.msg">
                <!-- 1 -->
                <div class="user-name d-flex"
                    v-if="!chat.owner && (index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)"
                    style="margin-bottom:0px;">
                    {{ chat.writer.name ? chat.writer.name.last + ' ' + chat.writer.name.first : $t("S10082") }}
                    <ProfileTierName :data="chat.writer" :class="'mgb-8 t-color-white chat-tier-name-background'" />
                </div>

                <!-- 2 -->
                <div class="picture position-relative" v-if="!chat.owner"
                    :class="{ 'first-avatar': (index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner) }">
                    <img class="avatar" :src="chat.writer.profile || '/images/avatar.svg'" alt=""
                        v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)" />
                    <ProfileTier :data="chat.writer"
                        v-if="(index === 0 && !chat.owner) || (index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner)"
                        :className="'size-18'" />
                </div>

                <!-- 3 -->
                <div class="text" :class="{
                    'me': chat.owner,
                    'other': !chat.owner,
                    'with-avatar': index === 0 && !chat.owner,
                    'with-avatar': index > 0 && listData[index - 1].writer.id !== chat.writer.id && !chat.owner,
                    'first': index > 0 && listData[index - 1].writer.id !== chat.writer.id,
                }">
                    <span class="t-body3">
                        {{ chat.msg ? chat.msg : 'No Message' }}
                    </span>
                </div>
                <span class="t-helper">
                    {{ $moment(chat.created).format('LT') }}
                </span>
            </div>

        </li>

    </ul>
</template>

<script>
import ProfileTier from '@/components/common/ProfileTier.vue';
import ProfileTierName from '@/components/common/ProfileTierName.vue';


/**
 * 나의학습/시험 질문하기 - 채팅 리스트 컴포넌트(my learn / exam question - chatting list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['listData'],
    components: { ProfileTier, ProfileTierName },
}
</script>
<style scoped>
img {
    width: 150px !important;
    width: 240px !important;
}

.user-name {
    flex: 0 0 100%;
    padding-left: 50px;
    margin-bottom: 5px;
    color: #909495;
    font-size: 0.75rem;
    font-weight: 400;
    display: inline-block;
}

#chat #chatContainer ul>li>div.chat-body {
    flex-wrap: wrap;
    position: relative;
}

img.avatar {
    height: 41px;
    width: 41px;
    border-radius: 50%;
    object-fit: cover;
}

.picture {
    position: absolute !important;
    top: 10px;
}

.text.me {
    margin: 0 !important;
}

.text.me.first {
    margin: 0 !important;
}

.text {
    max-width: 80%;
}

.text.other {
    margin-left: 50px !important;
}

.text.with-avatar {
    margin-left: 50px !important;
}

.text.first {
    margin-left: 50px !important;
}

.chat-tier-name-background {
    background: rgba(45, 109, 204, 0.5);
}

.first-avatar {
    margin-top: 22px;
}

.text.other {
    max-width: 60%;
}
</style>